export default __webpack_public_path__ + "static/media/after-effects.f58a9a13.png";